import React, { useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";
import { FaServer, FaPaintBrush } from "react-icons/fa";

const items = [
  { key: "experience", label: "Une expérience fluide", desc: "Navigation et achat simplifiés, sans friction.", icon: FaPaintBrush },
  { key: "verified", label: "Vérifié", desc: "Chaque commande est contrôlée individuellement.", icon: FaServer },
  { key: "delivery", label: "Livraison immédiate", desc: "Accès instantané aux fichiers après paiement validé.", icon: FaServer },
  { key: "access", label: "Accès aux fichiers", desc: "Téléchargement sécurisé de tous vos achats.", icon: FaPaintBrush },
  { key: "payments", label: "Paiements sécurisés", desc: "Transactions protégées et cryptées.", icon: FaServer },
  { key: "tracking", label: "Protection & suivi inclus", desc: "Suivi de commande et assistance intégrés.", icon: FaPaintBrush },
  { key: "team", label: "Équipe disponible sous 24h", desc: "Support réactif pour toute question.", icon: FaServer },
];

const Reassurance = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <section className="py-14" aria-labelledby="reassurance-title">
      <div className="max-w-7xl mx-auto px-4">
        <div
          className={`relative overflow-hidden border p-8 md:p-10 mb-8 shadow-xl ${
            isDark
              ? "border-white/10 bg-gradient-to-br from-rose-900/20 via-purple-900/20 to-blue-900/20"
              : "border-rose-100/80 bg-gradient-to-br from-rose-50 via-white to-orange-50 shadow-[0_24px_70px_rgba(15,23,42,0.08)]"
          }`}
        >
          <div className={`absolute -right-10 -top-10 h-32 w-32 rounded-full ${isDark ? "bg-rose-500/18" : "bg-rose-200/90"}`} />
          <div className={`absolute -left-12 -bottom-12 h-40 w-40 rounded-full ${isDark ? "bg-purple-500/10" : "bg-purple-100/80"}`} />

          <div className="relative flex items-center justify-between gap-4">
            <div>
              <h3 id="reassurance-title" className={`text-2xl font-semibold ${isDark ? "text-white" : "text-gray-900"}`}>
                Nos garanties
              </h3>
              <p className={`mt-3 text-base ${isDark ? "text-white/70" : "text-gray-600"}`}>
                Un parcours simple, rassurant et lisible pour acheter vos créations sans friction.
              </p>
            </div>
            <div className={`text-xs uppercase tracking-[0.2em] ${isDark ? "text-white/50" : "text-gray-500"}`}>
              Securite
            </div>
          </div>
        </div>

        <div
          className={`relative overflow-hidden border p-6 md:p-8 shadow-xl ${
            isDark
              ? "border-white/10 bg-white/5"
              : "border-rose-100/80 bg-gradient-to-br from-rose-50 via-white to-orange-50 shadow-[0_24px_70px_rgba(15,23,42,0.08)]"
          }`}
        >
          <div className={`absolute -right-10 -top-10 h-32 w-32 rounded-full ${isDark ? "bg-rose-500/18" : "bg-rose-200/90"}`} />
          <div className={`absolute -left-12 -bottom-12 h-40 w-40 rounded-full ${isDark ? "bg-purple-500/10" : "bg-purple-100/80"}`} />

          <div className="relative grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
            {items.map((it) => {
              const Icon = it.icon;
              return (
                <div
                  key={it.key}
                  className={`${isDark ? "bg-white/[0.05] border border-white/10 hover:border-rose-400/20 hover:bg-white/[0.06]" : "bg-white/90 border border-rose-100/80 hover:shadow-[0_18px_40px_rgba(15,23,42,0.06)]"} p-6 flex items-start gap-4 transition duration-300 shadow-xl bg-white/5`}
                  role="article"
                  aria-label={it.desc}
                >
                  <div className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center  ${isDark ? "bg-gradient-to-br from-rose-900/20 via-purple-900/20 to-blue-900/20 border border-white/10 shadow-xl" : "bg-rose-50"}`}>
                    <Icon className={`${isDark ? "text-rose-100" : "text-rose-600"} text-2xl`} />
                  </div>

                  <div className="flex-1">
                    <div className={`text-lg font-semibold ${isDark ? "text-white" : "text-gray-900"}`}>{it.label}</div>
                    <div className={`mt-1 text-sm ${isDark ? "text-white/65" : "text-gray-600"}`}>{it.desc}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reassurance;
